import React from 'react';

export default function SelectedThoughtModal({
                                                 thought,
                                                 onClose,
                                                 onEdit,
                                                 onDelete,
                                                 adminMode,
                                                 currentUserId,
                                             }) {
    if (!thought) return null;

    const isOwner = thought.user_id === currentUserId;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded p-6 shadow w-80">
                <div className="mb-4 whitespace-pre-wrap break-words text-gray-800">
                  {thought.content}
                  {thought.display_name && thought.display_name.trim() !== '' && (
                    <div className="mt-2 text-sm text-gray-500">
                      - {thought.display_name}
                      {thought.create_at && (
                        <> ({new Date(thought.create_at).toLocaleDateString()})</>
                      )}
                    </div>
                  )}
                </div>
                <div className="flex justify-between">
                    {isOwner ? (
                        <>
                            <button
                                onClick={onClose}
                                className="text-sm px-3 py-1 border rounded"
                            >
                                Close
                            </button>
                            <button
                                onClick={onEdit}
                                className="text-sm border px-3 py-1 rounded"
                            >
                                Edit
                            </button>
                            <button
                                onClick={async () => {
                                    if (window.confirm('Delete this thought?')) {
                                        await onDelete();
                                    }
                                }}
                                className="text-sm bg-red-500 text-white px-3 py-1 rounded"
                            >
                                Delete
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                onClick={onClose}
                                className="text-sm px-3 py-1 border rounded"
                            >
                                Close
                            </button>
                            {(adminMode || isOwner) && (
                                <button
                                    onClick={async () => {
                                        if (window.confirm('Delete this thought?')) {
                                            await onDelete();
                                        }
                                    }}
                                    className="text-sm bg-red-500 text-white px-3 py-1 rounded"
                                >
                                    Delete
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}